import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useFixedCouponSno } from '../../../hooks/useFixedCouponSno';
import { type GetGoodsCouponResponse, goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useGoodsCouponRedeemAll = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  const client = useQueryClient();
  return useMutation({
    throwOnError: false,
    mutationFn: () => {
      return goodsService.postRedeemAllGoodsCoupon(goodsSno, fixedCouponSno);
    },
    onSuccess: data => {
      client.setQueryData<GetGoodsCouponResponse>(
        queryKey.goodsCouponList(goodsSno, fixedCouponSno),
        oldData => {
          if (!oldData) return oldData;

          // redeemed_coupons 미응답이면 구버전 서버로 보고 기존처럼 전체를 발급 완료 처리
          const redeemedCouponSnos = new Set(
            data.redeemed_coupons ?? oldData.map(item => item.sno),
          );

          return oldData.map(item =>
            redeemedCouponSnos.has(item.sno)
              ? { ...item, is_issued: true }
              : item,
          );
        },
      );
      client.invalidateQueries({
        queryKey: queryKey.goodsCoupon(goodsSno),
      });
    },
  });
};
